module.exports = __webpack_public_path__ + "static/media/registp03_ja.2693f4b6.png";